import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../stores/auth.store';
import { UserPerfil } from '@aksape/types';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredPerfis?: UserPerfil[];
}

export function ProtectedRoute({ children, requiredPerfis }: ProtectedRouteProps) {
  const { isAuthenticated, user } = useAuthStore();
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/auth/login" state={{ from: location }} replace />;
  }

  if (requiredPerfis && user && !requiredPerfis.includes(user.perfil)) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
}
